var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E24545",
    fillRule: "nonzero",
    d: "M17.899 15.75L9.649 1.5a.78.78 0 0 0-1.298 0L.101 15.75a.75.75 0 0 0 .649 1.125h16.5a.75.75 0 0 0 .649-1.125zM9.904 6.375l-.354 4.95h-1.1l-.334-4.95h1.789zM9 14.625a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e0e2fd480a53a831a057bb20b962aeb2.svg";
export { ForwardRef as ReactComponent };